import { FC } from 'react';

import { I18nProvider } from '@i18n';

import { FilterProvider } from './InspirationAdviceFilter.context';
import { InspirationAdviceFilterView } from './InspirationAdviceFilter.view';

const InspirationAdviceFilter: FC = () => {
  return (
    <I18nProvider dictionary={locale => import(`./content/${locale}.json`)}>
      <FilterProvider>
        <InspirationAdviceFilterView />
      </FilterProvider>
    </I18nProvider>
  );
};

export default InspirationAdviceFilter;
